export * from './post-formular.component';
export * from './post-formular.component.module';